import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/theme/claimActivity_bg.png'
import _imports_1 from '@/assets/theme/text_t2.png'
import _imports_2 from '@/assets/theme/full_wash_chip.png'
import _imports_3 from '@/assets/themetwo/receiveBtn.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = { class: "taskListContainer" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_5 = { class: "closeICon" }

import { ref, computed, onMounted } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue'
import LoadingScreen from '@/components/common/loadingScreen.vue'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import CollectPopup from '@/view/collect/collectPopup.vue'
import CollectTimeDropPopup from '@/view/collect/collectTimeDropPopup.vue'
import AgentPopup from '@/view/agent/agentPopup.vue'
import CarteiraView from '@/view/carteiraView/carteiraView.vue'
import { useUserStore } from '@/stores/user'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { handleMenuClick } from '@/view/components/supportFunction'


export default /*@__PURE__*/_defineComponent({
  __name: 'claimListPopup',
  emits: ['handleShowTreasurePopup', 'resetShowTreasurePopup'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const router = useRouter()
const { t } = useI18n();
const show = ref(true)
const isSuccess = ref(false)
const statusRef = ref()
const toastContent = ref('')
const loadingRef = ref()
const rewardList = ref<any[]>(userStore.claimActivityList)

const agentRef = ref()
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const emits = __emit
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
    userStore.setIsClaimActivityList([])
    userStore.setIsOpenClaimPopup(false)
    emits('resetShowTreasurePopup')
}

const handleShowTreasurePopup = (path: any) => {
    emits('handleShowTreasurePopup', path)
    show.value = false
    localStorage.setItem('redirectFromCalim', 'true')
}
const goToPath = async (name: any) => {
   await handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
        pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t, handleShowTreasurePopup
    )
    userStore.setIsClaimActivityList([])
}

onMounted(() => {
    setTimeout(() => {
        show.value = true
        userStore.setIsOpenClaimPopup(true)
    }, 1000)
})

__expose({ open, close })

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      onClose: close,
      position: "center",
      style: {
        minWidth: '80%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '10005'
    }
    }, {
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "headImage" }, [
          _createElementVNode("img", {
            class: "image1",
            src: _imports_0,
            alt: ""
          }),
          _createElementVNode("img", {
            class: "image2",
            src: _imports_1,
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).claimActivityList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "taskCard",
                key: index
              }, [
                _createVNode(_component_van_row, {
                  onClick: ($event: any) => (goToPath(item.title))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_col, {
                      span: "4",
                      class: "activityIcon"
                    }, {
                      default: _withCtx(() => [
                        (item?.icon)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item?.icon,
                              alt: ""
                            }, null, 8, _hoisted_3))
                          : (_openBlock(), _createElementBlock("img", _hoisted_4))
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_col, {
                      span: "15",
                      class: "circleBtn taskName"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(`activityName.${item.title}`)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_van_col, { span: "5" }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createElementVNode("div", { class: "circleBtn" }, [
                          _createElementVNode("img", {
                            src: _imports_3,
                            alt: ""
                          })
                        ], -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_van_icon, {
            name: "cross",
            onClick: close,
            style: {"padding":"5px","background-color":"#cac8c45e","border-radius":"30px"}
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(CollectPopup, {
      ref_key: "collectPopupRef",
      ref: collectPopupRef
    }, null, 512),
    _createVNode(CollectTimeDropPopup, {
      ref_key: "collectTimeDropPopupRef",
      ref: collectTimeDropPopupRef
    }, null, 512),
    _createVNode(AgentPopup, {
      ref_key: "agentRef",
      ref: agentRef
    }, null, 512),
    _createVNode(CarteiraView, { ref: "walletPopupRef" }, null, 512),
    _createVNode(PwaAntiBlockingPopup, {
      ref_key: "pwaPopupRef",
      ref: pwaPopupRef
    }, null, 512),
    _createVNode(PwaStatusPopup, {
      ref_key: "pwaPopupStatusRef",
      ref: pwaPopupStatusRef
    }, null, 512),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"])
  ], 64))
}
}

})